import { useState } from 'react';

import AuthService from '@/services/auth.service';
import ContinueButton from '@/shared-components/buttons/components/ContinueButton';
import TextInput from '@/shared-components/inputs/components/new/TextInput';
import Text from '@/shared-components/text/components/Text';

import './styles/AuthArtistSignupForm.css';

export default function AuthArtistSignupForm({ oobCode, setOobCode, userEmail, setUserMail }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  async function claimArtistSubmit(e) {
    e.preventDefault();

    if(oobCode !== null) return;

    setLoading(true); 
    setError(null); 

    const { response, data } = await AuthService.claimArtistProfile(userEmail);

    if(response.ok) {
      setLoading(false);
      setOobCode(data.oobCode);
    } else if([400, 404, 409].includes(response.status)) {
      setLoading(false);
      setError({ element: data.error_data.element, error_code: data.error_type });
    } 
  }

  const onInputChange = (value) => {
    setUserMail(value);
  };

  return (
    <>
      <Text className="auth-artist-signup__text font-size-small" paragraph justify>
        Is your art featured on Suarte? Simply enter the email connected with your artworks, previously provided by the Gallery that represents you.
      </Text>
      <form onSubmit={claimArtistSubmit} className="auth-artist-signup__form">
        <div className="auth-artist-signup__email-container">
          <TextInput 
            type='email'
            error={error}
            label="Email"
            placeholder='Email'
            value={userEmail} element="user_email" margin 
            onChange={(e) => onInputChange(e.target.value)} 
            // readOnly={loading || Boolean(oobCode)} --- TODO: Add to new component ---
          />
        </div>

        {!oobCode && (
          <ContinueButton loading={loading} turnOff={loading}>
            Continue 
          </ContinueButton>
        )}
      </form>
    </>
  );
}
